interface ContainerProps {
  children: React.ReactNode
  className?: string
}

export const EmptyState = ({ children, className = '' }: ContainerProps) => (
  <div className={`flex flex-col items-center justify-center w-[500px] mx-auto ${className}`}>
    {children}
  </div>
)

const Content = ({ children, className = '' }: ContainerProps) => (
  <div className={`flex flex-col gap-y-4 mt-8 items-center ${className}`}>{children}</div>
)

const TextWrapper = ({ children, className = '' }: ContainerProps) => (
  <div className={`text-center ${className}`}>{children}</div>
)

EmptyState.Content = Content
EmptyState.TextWrapper = TextWrapper
